import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../environments/environment';
import { SharedService } from './shared/shared.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet><spinner></spinner></router-outlet>',
  providers: [SharedService]
})
@Injectable()
export class AppComponent {
  headers: Headers;
  constructor(private http: Http,
    private sharedService: SharedService) {
    this.headers = new Headers();
    this.headers.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    sharedService.checkLanguage();
  }
}



// WEBPACK FOOTER //
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/app.component.ts